/*
 * Emma's Choice premium layer: previous / next buttons for ech-* swipe rows.
 * A row is a [data-ech-scroller] holding a [data-ech-track] list and,
 * optionally, [data-ech-prev] / [data-ech-next] buttons.
 */
(() => {
  const parts = (scroller) => ({
    track: scroller.querySelector('[data-ech-track]'),
    prev: scroller.querySelector('[data-ech-prev]'),
    next: scroller.querySelector('[data-ech-next]'),
  });

  const sync = (scroller) => {
    const { track, prev, next } = parts(scroller);
    if (!track || !prev || !next) return;
    const max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
    const hidden = max <= 2;
    prev.hidden = hidden;
    next.hidden = hidden;
  };

  const init = (root) => {
    root.querySelectorAll('[data-ech-scroller]').forEach((scroller) => {
      const { track } = parts(scroller);
      if (!track || scroller.dataset.echReady) return;
      scroller.dataset.echReady = 'true';
      track.addEventListener('scroll', () => sync(scroller), { passive: true });
      sync(scroller);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ech-prev], [data-ech-next]');
    if (!button) return;
    const scroller = button.closest('[data-ech-scroller]');
    const { track } = parts(scroller);
    if (!track) return;
    const item = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    const direction = button.hasAttribute('data-ech-next') ? 1 : -1;
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-ech-scroller]').forEach(sync);
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  init(document);
})();
